"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const Delay_1 = __importDefault(require("./Utils/Delay"));
const breakpoints = {
    sm: 544,
    md: 768,
    lg: 992,
    xl: 1200 // Extra large screen / wide desktop
};
const Services = {
    providerCallbacks: {
        booting: [],
        boot: [],
        booted: [],
    },
    onLoadCallbacks: {
        booting: [],
        boot: [],
        booted: [],
    },
    start: function () {
        this.bootProviderCallback.init();
        this.bootOnLoadCallback.init();
    },
    /**
     * @returns {boolean}
     */
    isRTL: function () {
        const html = $('html');
        if (html.length) {
            return html.attr('direction') === 'rtl' || html.attr('dir') === 'rtl';
        }
        return false;
    },
    css: function (el, styleProp, value) {
        if (!el) {
            return;
        }
        if (value !== undefined) {
            el.style[styleProp] = value;
        }
        else {
            const defaultView = (el.ownerDocument || document).defaultView;
            // W3C standard way:
            if (defaultView && defaultView.getComputedStyle) {
                // sanitize property name to css notation
                // (hyphen separated words eg. font-Size)
                styleProp = styleProp.replace(/([A-Z])/g, "-$1").toLowerCase();
                return defaultView.getComputedStyle(el, null).getPropertyValue(styleProp);
            }
            else if (el.currentStyle) { // IE
                // sanitize property name to camelCase
                styleProp = styleProp.replace(/\-(\w)/g, function (str, letter) {
                    return letter.toUpperCase();
                });
                value = el.currentStyle[styleProp];
                // convert other units to pixels on IE
                if (/^\d+(em|pt|%|ex)?$/i.test(value)) {
                    return (function (value) {
                        const oldLeft = el.style.left, oldRsLeft = el.runtimeStyle.left;
                        el.runtimeStyle.left = el.currentStyle.left;
                        el.style.left = value || 0;
                        value = el.style.pixelLeft + "px";
                        el.style.left = oldLeft;
                        el.runtimeStyle.left = oldRsLeft;
                        return value;
                    })(value);
                }
                return value;
            }
        }
    },
    remove: function (el) {
        if (el && el.parentNode) {
            el.parentNode.removeChild(el);
        }
    },
    addClass: function (el, className) {
        if (!el || typeof className === 'undefined') {
            return;
        }
        const classNames = className.split(' ');
        if (el.classList) {
            for (let i = 0; i < classNames.length; i++) {
                if (classNames[i] && classNames[i].length > 0) {
                    el.classList.add(Services.trim(classNames[i]));
                }
            }
        }
        else if (!this.hasClass(el, className)) {
            for (let x = 0; x < classNames.length; x++) {
                el.className += ' ' + Services.trim(classNames[x]);
            }
        }
    },
    hasClass: function (el, className) {
        if (!el) {
            return;
        }
        return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
    },
    hasClasses: function (el, classes) {
        if (!el) {
            return;
        }
        const classesArr = classes.split(" ");
        for (let i = 0; i < classesArr.length; i++) {
            if (this.hasClass(el, this.trim(classesArr[i])) == false) {
                return false;
            }
        }
        return true;
    },
    trim: function (string) {
        return string.trim();
    },
    actualCss: function (el, prop, cache) {
        let css = '';
        if (!(el instanceof HTMLElement)) {
            return;
        }
        if (!el.getAttribute('kt-hidden-' + prop) || cache === false) {
            let value;
            // the element is hidden so:
            // making the el block so we can meassure its height but still be hidden
            css = el.style.cssText;
            el.style.cssText = 'position: absolute; visibility: hidden; display: block;';
            if (prop === 'width') {
                value = el.offsetWidth;
            }
            else if (prop === 'height') {
                value = el.offsetHeight;
            }
            el.style.cssText = css;
            // store it in cache
            el.setAttribute('kt-hidden-' + prop, value);
            return parseFloat(value);
        }
        else {
            // store it in cache
            return parseFloat(el.getAttribute('kt-hidden-' + prop));
        }
    },
    actualHeight: function (el, cache) {
        return Services.actualCss(el, 'height', cache);
    },
    actualWidth: function (el, cache = undefined) {
        return Services.actualCss(el, 'width', cache);
    },
    getBreakpoint: function (mode) {
        return breakpoints[mode];
    },
    getViewPort: function () {
        let e = window, a = 'inner';
        if (!('innerWidth' in window)) {
            a = 'client';
            e = document.documentElement || document.body;
        }
        return {
            width: e[a + 'Width'],
            height: e[a + 'Height']
        };
    },
    isMobileDevice: function () {
        let test = (this.getViewPort().width < this.getBreakpoint('lg'));
        if (test === false) {
            // For use within normal web clients
            test = navigator.userAgent.match(/iPad/i) != null;
        }
        return test;
    },
    isDesktopDevice: function () {
        return !this.isMobileDevice();
    },
    getUniqueID: function (prefix) {
        return prefix + Math.floor(Math.random() * (new Date()).getTime());
    },
    getRandomInt: function (min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    isEmpty: function (data) {
        return (data === '' || lodash_1.default.isUndefined(data) || (lodash_1.default.isEmpty(data) && data.length === 0));
    },
    checkPassword: function (t) {
        return (/^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/).test(t);
    },
    serializeObject: function () {
        const o = {};
        const a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            }
            else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    },
    convertToFaDigit: function (number) {
        let b = number.toString();
        for (let c = 48; c <= 57; c++) {
            const d = String.fromCharCode(c);
            const e = String.fromCharCode(c + 1728);
            b = b.replace(new RegExp(d.toString(), "g"), e.toString());
        }
        return b;
    },
    convertToEnDigit: function (number) {
        return number.toString()
            .replace(/۰/g, '0')
            .replace(/۱/g, '1')
            .replace(/۲/g, '2')
            .replace(/۳/g, '3')
            .replace(/۴/g, '4')
            .replace(/۵/g, '5')
            .replace(/۶/g, '6')
            .replace(/۷/g, '7')
            .replace(/۸/g, '8')
            .replace(/۹/g, '9')
            .replace(/٠/g, '0')
            .replace(/١/g, '1')
            .replace(/٢/g, '2')
            .replace(/٣/g, '3')
            .replace(/٤/g, '4')
            .replace(/٥/g, '5')
            .replace(/٦/g, '6')
            .replace(/٧/g, '7')
            .replace(/٨/g, '8')
            .replace(/٩/g, '9');
    },
    formatCurrency: function (price, toFaNumber = true) {
        const formatted = price.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return toFaNumber ? this.convertToFaDigit(formatted) : formatted;
    },
    clearSymbolCurrency: function (price) {
        return price.toString().replace(/,/g, '');
    },
    isPersianMobileNumber: function (mobile) {
        mobile = this.convertToEnDigit(mobile);
        return new RegExp("^(\\+98|0|98|0098)([ ]|-|[()]){0,2}9\\d([ ]|-|[()]){0,2}(?:\\d([ ]|-|[()]){0,2}){8}$").test(mobile);
    },
    setCookie: function (cookieName, cookieValue, expireDays) {
        const d = new Date();
        d.setTime(d.getTime() + (expireDays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + cookieValue + ";" + expires + ";path=/";
    },
    getCookie: function (cookieName) {
        const name = cookieName + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    checkCookie: function (cookieName) {
        const name = this.getCookie(cookieName);
        return name !== "";
    },
    nl2br: function (str) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        const breakTag = '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    },
    arrayToObjectKey: function (array) {
        const output = {};
        array.reduce(function (object, value) {
            return Object.assign(object, { [value]: 1 });
        }, output);
        return output;
    },
    getQueryString: function (url) {
        if (typeof url !== 'string' || url.indexOf('?') < 0)
            return '';
        return url.substring(url.indexOf('?'));
    },
    parseQueryString: function (query) {
        if (!query || typeof query !== 'string')
            return {};
        query = query.substring(1);
        const queryString = {};
        const vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
            if (vars[i] === "") {
                continue;
            }
            const pair = vars[i].split("=");
            const key = pair[0];
            const value = pair.length > 1 ? pair[1] : "";
            try {
                const paramValue = decodeURIComponent(value.replace(/\+/g, "%20"));
                if (typeof queryString[key] === "undefined") {
                    queryString[key] = paramValue;
                }
                else {
                    if (typeof queryString[key] === "string") {
                        queryString[key] = [queryString[key], paramValue];
                    }
                    else {
                        queryString[key].push(paramValue);
                    }
                }
            }
            catch (err) {
            }
        }
        return queryString;
    },
    isFunction: function (variable) {
        return variable && Object.prototype.toString.call(variable) === '[object Function]';
    },
    isObject: function (variable) {
        return variable && Object.prototype.toString.call(variable) === '[object Object]';
    },
    isArray: function (variable) {
        return Object.prototype.toString.call(variable) === '[object Array]';
    },
    getConstructor: function (f) {
        try {
            return new f();
        }
        catch (err) {
            return false;
        }
    },
    scrollWindowToList: function () {
        $('html, body').animate({ scrollTop: 0 }, 500);
    },
    delay: function () {
        return new Delay_1.default();
    },
    numberWithCommas: function (x) {
        return x.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    URL: {
        /**
         * @example => http://example.test/test-page?q=tset#test-hash
         */
        full: function () {
            return window.location.href;
        },
        /**
         * @example => /test-page?q=test#test-hash
         */
        fullWithoutOrigin: function () {
            return this.path() + this.queryString() + this.hash();
        },
        /**
         * @example => /test-page?q=test
         */
        fullWithoutOriginAndHash: function () {
            return this.path() + this.queryString();
        },
        /**
         * @example => http://example.test
         */
        origin: function () {
            return window.location.origin;
        },
        /**
         * @example => example.test
         */
        host: function () {
            return window.location.host;
        },
        /**
         * @example => /test-page
         */
        path: function () {
            return window.location.pathname;
        },
        /**
         * @example => #test-hash
         */
        hash: function () {
            return window.location.hash;
        },
        /**
         * @example => ?q=test&query-test[]=test-value
         */
        queryString: function () {
            return window.location.search;
        },
        /**
         @example => [http://example.test] + [path = /path/to/page] => http://example.test/path/to/page
         */
        createWithOrigin: function (path) {
            if (path.startsWith('/')) {
                return this.origin() + path;
            }
            return this.origin() + '/' + path;
        },
        /**
         @example => [example.test] + [path = /path/to/page] => example.test/path/to/page
         */
        createWithHost: function (path) {
            if (path.startsWith('/')) {
                return this.host() + path;
            }
            return this.host() + '/' + path;
        },
        /**
         * @see Validate a URL
         * @param path {string}
         * @return boolean
         */
        isValid: function (path) {
            const pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
                '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
                '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
                '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
            return !!pattern.test(path);
        }
    },
    Request: {
        redirect: function (data) {
            return window.location.replace(data);
        },
        back: function () {
            window.history.back();
        },
        reload: function () {
            return window.location.reload();
        }
    },
    bootOnLoadCallback: {
        init: function () {
            const $this = this;
            $(window).on("load", function (event) {
                $this.booting(event);
                $this.boot(event);
                $this.booted(event);
            });
        },
        boot: function (event) {
            const $boot = Services.onLoadCallbacks.boot;
            if ($boot.length > 0) {
                $boot.forEach(function (item) {
                    item.callback(...[event, ...item.arguments]);
                });
            }
        },
        booting: function (event) {
            const $boot = Services.onLoadCallbacks.booting;
            if ($boot.length > 0) {
                $boot.forEach(function (item) {
                    item.callback(...[event, ...item.arguments]);
                });
            }
        },
        booted: function (event) {
            const $boot = Services.onLoadCallbacks.booted;
            if ($boot.length > 0) {
                $boot.forEach(function (item) {
                    item.callback(...[event, ...item.arguments]);
                });
            }
        }
    },
    bootProviderCallback: {
        init: function () {
            this.booting();
            this.boot();
            this.booted();
        },
        boot: function () {
            const $boot = Services.providerCallbacks.boot;
            if ($boot.length > 0) {
                $boot.forEach(function (item) {
                    item.callback(...item.arguments);
                });
            }
        },
        booting: function () {
            const $boot = Services.providerCallbacks.booting;
            if ($boot.length > 0) {
                $boot.forEach(function (item) {
                    item.callback(...item.arguments);
                });
            }
        },
        booted: function () {
            const $boot = Services.providerCallbacks.booted;
            if ($boot.length > 0) {
                $boot.forEach(function (item) {
                    item.callback(...item.arguments);
                });
            }
        }
    },
    humanFileSize: function ($size, $unit = '') {
        if ((!$unit && $size >= 1 << 30) || $unit === "GB") {
            return this.numberWithCommas(($size / (1 << 30)).toFixed(2)) + " GB";
        }
        if ((!$unit && $size >= 1 << 20) || $unit === "MB") {
            return this.numberWithCommas(($size / (1 << 20)).toFixed(2)) + " MB";
        }
        if ((!$unit && $size >= 1 << 10) || $unit === "KB") {
            return this.numberWithCommas(($size / (1 << 10)).toFixed(2)) + " KB";
        }
        return this.numberWithCommas($size) + " bytes";
    },
    pluckObject: function (object, key) {
        const response = [];
        for (const item of object) {
            response.push(item[key]);
        }
        return response;
    },
    initPageLoader: () => {
        window.preloader = new Promise((resolve, reject) => {
            $(document).find('.page-loader').fadeOut(500, function () {
                $('body').removeClass('page-loading');
                resolve(this);
            });
        });
    },
    initTooltips: function () {
        const initTooltip = function (el) {
            const theme = el.data('theme') ? 'tooltip-' + el.data('theme') : '';
            const width = el.data('width') === 'auto' ? 'tooltop-auto-width' : '';
            const trigger = el.data('trigger') ? el.data('trigger') : 'hover';
            $(el).tooltip({
                trigger: trigger,
                template: '<div class="tooltip ' + theme + ' ' + width + '" role="tooltip">\
                            <div class="arrow"></div>\
                            <div class="tooltip-inner"></div>\
                        </div>'
            });
        };
        return function () {
            // init bootstrap tooltips
            $('[data-toggle="tooltip"]').each(function () {
                initTooltip($(this));
            });
        }();
    },
    captureError: function (exception) {
        if (typeof window.Sentry != "undefined") {
            window.Sentry.captureException(exception);
        }
    },
};
exports.default = Services;
